$('body').addClass('lang-'+dataLayer[0].shoptet.language)
    if($('body').hasClass('lang-cs')){
        var loginacount = 'Uživatelské jméno nebo e-mail'
        var loginpasword = 'Heslo'
        var zobrazuji = 'Zobrazuji'
        var z = 'z'
        var favorite_text = 'Vložit do oblíbených'
        var doprava_text = 'Informace o bezpečné dopravě'
        var doruceni_text = 'Můžeme doručit do: '
        var searchtitle = 'Zadaný výraz nebyl nalezen'
        var searchsubtitle = 'Moc nás to mrzí, ale hledanému výrazu jsme nenašli odpovídající produkt ani stránku. Zadejte jiný výraz.'
        var emptycarttitle = 'Váš košík je momentálně prázdný.'
        var emptycartetext1 = 'Pokud si nevíte rady s výběrem, neváhejte nás '
        var emptycartcontact = 'kontaktovat'
        var emptycarttext2 = 'Naši specialisti vám poradí.'
        var linktocontact = '/kontakty/'
    
        var addtocart = 'Úspěšně jste přidali do košíku'
        var tocart = 'Přejít do košíku'
        var castonakupuji = 'S těmito produkty zákazníci také koupili­'
        var backtoshop = 'Zpět do obchodu'
        var slevovypoukaz = 'Mám slevový kupón'
        var incategory = 'Nalezeno v kategoriích'
        var innews = 'Nalezeno ve článcích'
        var favorite_url = '/oblibene/'
        var popisprazdnykosik = 'Doporučujeme prohlédnout <a href="/detska-obuv/">dětskou obuv</a>, <a href="/obuv-pro-dospele/">obuv pro dospělé</a> nebo <a href = "/doplnky/">doplňky</a>.'
        //var nenalezeno = '<h2>Zadaný výraz nebyl nalezen</h2><p>Moc nás to mrzí, ale hledanému výrazu jsme nenašli odpovídající produkt ani stránku. Zadejte jiný výraz.</p>'
        var backtoshoplink = 'Zpět do e-shopu'
        var darky_slevy = 'Dárky a slevy'

        var reglink = '/registrace'
        var regtext = 'Registrace'

        var textstitky = 'Štítky'

        var registrace = '.in-registrace'
    }
    
